
import fakeData from '../../fakeData';
import React, { useState, useEffect } from 'react';
import './Shop.css'
import Product from '../Products/Product';
import Cart from '../Cart/Cart';
// import { addToDb } from '../../utilities/fakedb';
import { addToDatabaseCart, getDatabaseCart } from '../../utilities/databaseManager';
import { Link } from 'react-router-dom';


const Shop = () => {
     const first10 = fakeData.slice(0,20);
     const [products, setProducts] = useState(first10);
     const [cart,setCart] = useState([]);

     useEffect(() => {
      const savedCart = getDatabaseCart();
      const productKeys = Object.keys(savedCart);
      const previousCart = productKeys.map(existingkey => {
            const product = fakeData.find(pd => pd.key === existingkey)
            product.quantity = savedCart[existingkey];
            return product;
            

      })
      setCart(previousCart);
}, []);

     const handlAddProduct = (product) =>{
      const toBeAddedkey = product.key;
      const sameProduct = cart.find(pd => pd.key === toBeAddedkey);
      let count = 1;
      let newCart;
      if(sameProduct){
            count = sameProduct.quantity + 1;
            sameProduct.quantity = count;
            const others = cart.filter(pd => pd.key !== toBeAddedkey);
            newCart = [...others, sameProduct];
      }
      else{
            product.quantity = 1;
            newCart = [...cart,product];
      }
     
      setCart(newCart);
      
      addToDatabaseCart(product.key,count);
     } 





      return (
            <div className='twin-container'>
                  <div className="product-container">
                  
                              {
                                    products.map(pd => <Product
                                    key = {pd.key}
                                          showAddToCart = {true}
                                          handlAddProduct = {handlAddProduct}
                                          product={pd}></Product>)
                              }
                  
                  </div>
                  <div className="card-container">
                        <Cart cart={cart}>
                        <Link to = "/review">
                        <button className='mainBtn'>Review Order</button>
                        </Link>
                        </Cart>


                  </div>
                  
            </div>
      )
}

export default Shop;